'use client';

import type { FC, JSX } from 'react';
import React, { useState } from 'react';
import { CircleCaretDown } from '@/Theme/SVG/Svgs';
import Keys from '@/Translations/generated/da/hero.json.keys';
import { Language } from '@/app/i18n/settingsClient';
import { useTranslation } from '@/app/i18n/client';
import { useWindow } from '@ibe/components';
import { scrollElementId } from '@/Util/globals';
import { useIsComponentMounted } from '@/Hooks/useIsComponentMounted';

const getTextStartOffset = (locale: string): number => {
  switch (locale) {
    case Language.DA:
    case Language.NO:
      return 9;
    case Language.FI:
      return 16;
    case Language.SV:
      return 13;
    default:
      return 2;
  }
};

const getTextLength = (locale: string): number | undefined => {
  switch (locale) {
    case Language.PL:
      return 130;
    default:
      return undefined;
  }
};

const ScrollBtn: FC<{ hideScrollBtn?: boolean; smallVersion?: boolean; locale: string }> = ({
  hideScrollBtn,
  smallVersion,
  locale
}): JSX.Element => {
  const { t } = useTranslation('hero');
  const window = useWindow();
  const [hoverState, setHoverState] = useState<boolean>(false);
  const isMounted = useIsComponentMounted();

  const scrollDown = (): void => {
    const scrollElement = window?.document?.getElementById(scrollElementId);
    if (scrollElement) {
      scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {!hideScrollBtn && !smallVersion ? (
        <div
          className={`hero__down${hoverState ? ' hero__down--hover' : ''}`}
          onClick={scrollDown}
          onMouseEnter={(): void => setHoverState(true)}
          onMouseLeave={(): void => setHoverState(false)}
        >
          {isMounted ? (
            <CircleCaretDown
              text={t(Keys.scrollForMore)}
              textLength={getTextLength(locale)}
              textStartOffset={getTextStartOffset(locale)}
              className={locale === Language.PL ? 'circle-caret-down--pl' : ''}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ScrollBtn;
